// This function allow to reference all chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "" + "Header" + "_" + "01200d4a3d000c6c" + ".css";
};